import { gql } from 'apollo-angular'

export default gql`
  mutation delete_facility_by_pk($id: Int!) {
    delete_facility(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
